import 'core-js/stable';
import Vue from 'vue';
import App from './App';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { iconsSet as icons } from './assets/icons/icons.js';
import store from './store';
import { AUTH_LOGOUT } from './store/actions/auth';

import axios from 'axios';
import VueAxios from 'vue-axios';
import { Plugin } from 'vue-fragment';
import 'regenerator-runtime/runtime.js'
import './assets/css/tailwind.css'
import Vuex from 'vuex'
import Vueditor from 'vueditor'
import 'vueditor/dist/style/vueditor.min.css'
import ErrorService from './services/ErrorService'
import RestaurantTableOrderBadge from './components/RestaurantTableOrderBadge'

Vue.component('RestaurantTableOrderBadge', RestaurantTableOrderBadge)

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.prototype.$log = console.log.bind(console);

Vue.use(Vuex);
Vue.use(Vueditor);

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

let isRefreshing = false;
let refreshSubscribers = [];

const onRefreshed = newAccessToken => {
    refreshSubscribers.forEach(callback => callback(newAccessToken));
    refreshSubscribers = [];
};

// Добавляем request интерцептор для сбора контекста
Vue.axios.interceptors.request.use(
    (config) => {
        // Маркируем начало запроса и подготавливаем поле action
        // Можно передавать кастомный config.__action при вызове
        config.__action = config.__action || `${(config.method || 'GET').toUpperCase()} ${config.url || ''}`.trim();
        config.metadata = { startTs: Date.now() };
        return config;
    },
    (error) => {
        // Нормализуем и логируем сетевые ошибки до отправки
        try {
            const normalized = ErrorService.normalize(error, error && error.config);
            ErrorService.show(normalized);
            ErrorService.log(normalized);
            // Пробрасываем дальше
            error.__normalized = normalized;
        } catch (_) {}
        return Promise.reject(error);
    }
);

Vue.axios.interceptors.response.use(
    response => response,
    async error => {
        const { response } = error;
        if (response && response.status === 401) {
            if (isRefreshing) {
                return new Promise(resolve => {
                    refreshSubscribers.push(newAccessToken => {
                        error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;
                        resolve(Vue.axios(error.config));
                    });
                });
            }

            isRefreshing = true;

            try {
                const newAccessToken = await store.dispatch('refreshAccessToken');
                error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;

                onRefreshed(newAccessToken);
                return Vue.axios(error.config);
            } catch (refreshError) {
                // Показать понятное сообщение и залогировать
                const normalized = ErrorService.normalize(response ? error : refreshError, error && error.config);
                // Перепишем статус на 401 для корректного текста
                normalized.status = 401;
                ErrorService.show(normalized);
                ErrorService.log(normalized);
                await store.dispatch(AUTH_LOGOUT);
                router.push('/pages/login');
            } finally {
                isRefreshing = false;
            }
        }

        try {
            const normalized = ErrorService.normalize(error, error && error.config);

            // Для 400/422 с валидацией прокинем детали дальше в error
            if (normalized.status === 400 || normalized.status === 422) {
                // Показываем общий верхний блок-инструкцию через алерт (если не подавлен)
                if (!(error.config && error.config.__suppressGlobalError)) {
                    ErrorService.show(normalized);
                }
                ErrorService.log(normalized);
                // Построим карту ошибок полей, если есть
                const fieldMap = ErrorService.buildFieldErrorsMap(normalized.details);
                error.__normalized = { ...normalized, fieldErrors: fieldMap };
                // Эмитим событие для форм, чтобы подсветить поля
                if (fieldMap && Object.keys(fieldMap).length && Vue.prototype.$root && Vue.prototype.$root.$emit) {
                    Vue.prototype.$root.$emit('serverValidationErrors', fieldMap);
                }
                // Бизнес-логика может прочитать error.__normalized.details для подсветки полей
                return Promise.reject(error);
            }

            // Для остальных статусов показываем тост/алерт (если не подавлен) и логируем
            if (!(error.config && error.config.__suppressGlobalError)) {
                ErrorService.show(normalized);
            }
            ErrorService.log(normalized);
            error.__normalized = normalized;
        } catch (_) {}

        return Promise.reject(error);
    }
);

const token = localStorage.getItem('user-token');
if(token) {
    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    // Load actual permissions
    const id = JSON.parse(localStorage.getItem('profile')).id;
    Vue.axios
        .get('/administrators/' + id + '/settings')
        .then(resp => {
            localStorage.setItem('settings', JSON.stringify(resp.data));
        })
        .catch(err => {
            console.log('Cannot load administrator\'s settings.');
        });
}

Vue.use(Plugin);

new Vue({
    el: '#app',
    router,
    store,
    icons,
    components: {
        App
    },
    template: '<App/>'
})
